import React, {
  useState,
  useEffect
} from 'react';

import {SiteLinks} from '../../general';

function ThesisDefensePageInfo() {
  return (<SiteLinks screen="s2_student_sidang" />);
}

export {ThesisDefensePageInfo};